// extracted by mini-css-extract-plugin
module.exports = {"container":"_c5478fcb","fraction":"_ac7c7be6"};